export default __webpack_public_path__ + "static/media/3g-icon.48bc36d0.png";